import {useParams} from 'react-router-dom';

import {Stack} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {useBankAccount} from '../hooks/useBankAccount.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';
import {EditPageNavigation} from "../navigation/BreadcrumbsNavigation.tsx";
import {AiOutlineBank} from "react-icons/ai";

export const EditPage = () => {

    const {
        id: customerId,
        bankAccountId
    } = useParams();

    if (typeof customerId === 'undefined') {
        throw new Error('customerId is required parameter')
    }

    if (typeof bankAccountId === 'undefined') {
        throw new Error('bankAccountId is required parameter');
    }

    const {
        record: component,
        loading,
        updateRecord,
    } = useBankAccount(customerId, bankAccountId);

    const {
        mode,
        tools,
    } = useEditPageTools();

    if (loading || !component) {
        return <PlatformLoader message='Loading application...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={component.accountHolderName ? component.accountHolderName : component.id}
            icon={<AiOutlineBank/>}
            pageNavigation={<EditPageNavigation record={component}/>}
            tools={tools}
        >


            {mode === 'view' ?
                <Stack gap='lg'>
                    <Profile
                        record={component}
                    />
                </Stack>
                :
                <RecordForm
                    record={component}
                    handleSubmit={updateRecord}
                />}


        </FormPageLayout>
    );
};
